import { lazy } from 'react';

export default {
  path: '/reports',
  component: lazy(() => import(/* webpackChunkName: 'Reports' */ './page'))
};
